export const state = {
    themes: [],
    themeGroups: []
};

export default state;
